/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPlatformUserPackageParams,
  PlatformUserPackageItemTransactionModel,
  PlatformUserPackageModel,
  PlatformUserPackagesCreatedEvent,
  RedeemPlatformUserPackageItemInAppRequest,
  RedeemPlatformUserPackageItemRequest
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Returns a list of PlatformUserPackageModels of the current user.
 */
export const getPlatformUserPackages = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformUserPackageModel[]>(
      {url: `/api/v1/platform-user-packages`, method: 'GET', signal
    },
      options);
    }




export const getGetPlatformUserPackagesQueryKey = () => {
    return [
    `/api/v1/platform-user-packages`
    ] as const;
    }


export const getGetPlatformUserPackagesQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformUserPackages>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserPackages>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformUserPackagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformUserPackages>>> = ({ signal }) => getPlatformUserPackages(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserPackages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformUserPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformUserPackages>>>
export type GetPlatformUserPackagesQueryError = ErrorType<unknown>


/**
 * @summary Returns a list of PlatformUserPackageModels of the current user.
 */

export function useGetPlatformUserPackages<TData = Awaited<ReturnType<typeof getPlatformUserPackages>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserPackages>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformUserPackagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns a platform user package model based on the given package id.
 */
export const getPlatformUserPackage = (
    packageId: string,
    params: GetPlatformUserPackageParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformUserPackageModel>(
      {url: `/api/v1/platform-user-packages/${packageId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlatformUserPackageQueryKey = (packageId: string,
    params?: GetPlatformUserPackageParams,) => {
    return [
    `/api/v1/platform-user-packages/${packageId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlatformUserPackageQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformUserPackage>>, TError = ErrorType<unknown>>(packageId: string,
    params: GetPlatformUserPackageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserPackage>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformUserPackageQueryKey(packageId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformUserPackage>>> = ({ signal }) => getPlatformUserPackage(packageId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: packageId !== null && packageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserPackage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformUserPackageQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformUserPackage>>>
export type GetPlatformUserPackageQueryError = ErrorType<unknown>


/**
 * @summary Returns a platform user package model based on the given package id.
 */

export function useGetPlatformUserPackage<TData = Awaited<ReturnType<typeof getPlatformUserPackage>>, TError = ErrorType<unknown>>(
 packageId: string,
    params: GetPlatformUserPackageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserPackage>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformUserPackageQueryOptions(packageId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Creates PlatformUserPackages based on MembershipRewards ids.
This endpoint is currently used for acquiring Membership rewards/treatments.
 */
export const createPlatformUserPackage = (
    platformUserMembershipId: string,
    createPlatformUserPackageBody: string[],
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformUserPackagesCreatedEvent>(
      {url: `/api/v1/platform-user-packages/${platformUserMembershipId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPlatformUserPackageBody, signal
    },
      options);
    }




export const getCreatePlatformUserPackageMutationKey = () => ['createPlatformUserPackage'] as const;

export const getCreatePlatformUserPackageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatformUserPackage>>, TError,CreatePlatformUserPackageMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof createPlatformUserPackage>>, TError,CreatePlatformUserPackageMutationVariables, TContext> => {

const mutationKey = getCreatePlatformUserPackageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlatformUserPackage>>, CreatePlatformUserPackageMutationVariables> = (props) => {
          const {platformUserMembershipId,data} = props ?? {};

          return  createPlatformUserPackage(platformUserMembershipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePlatformUserPackageMutationResult = NonNullable<Awaited<ReturnType<typeof createPlatformUserPackage>>>
    export type CreatePlatformUserPackageMutationBody = string[]
    export type CreatePlatformUserPackageMutationError = ErrorType<unknown>
    export type CreatePlatformUserPackageMutationVariables = {platformUserMembershipId: string;data: string[]}

    /**
 * @summary Creates PlatformUserPackages based on MembershipRewards ids.
This endpoint is currently used for acquiring Membership rewards/treatments.
 */
export const useCreatePlatformUserPackage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatformUserPackage>>, TError,CreatePlatformUserPackageMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPlatformUserPackage>>,
        TError,
        CreatePlatformUserPackageMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePlatformUserPackageMutationOptions(options));
    }
    /**
 * @summary Redeems a PlatformUserPackageItem based on the scanned QR code.
 */
export const redeemPlatformUserPackageItem = (
    redeemPlatformUserPackageItemRequest: RedeemPlatformUserPackageItemRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformUserPackageItemTransactionModel[]>(
      {url: `/api/v1/platform-user-package-items/redeem`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: redeemPlatformUserPackageItemRequest, signal
    },
      options);
    }




export const getRedeemPlatformUserPackageItemMutationKey = () => ['redeemPlatformUserPackageItem'] as const;

export const getRedeemPlatformUserPackageItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemPlatformUserPackageItem>>, TError,RedeemPlatformUserPackageItemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemPlatformUserPackageItem>>, TError,RedeemPlatformUserPackageItemMutationVariables, TContext> => {

const mutationKey = getRedeemPlatformUserPackageItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemPlatformUserPackageItem>>, RedeemPlatformUserPackageItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  redeemPlatformUserPackageItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemPlatformUserPackageItemMutationResult = NonNullable<Awaited<ReturnType<typeof redeemPlatformUserPackageItem>>>
    export type RedeemPlatformUserPackageItemMutationBody = RedeemPlatformUserPackageItemRequest
    export type RedeemPlatformUserPackageItemMutationError = ErrorType<unknown>
    export type RedeemPlatformUserPackageItemMutationVariables = {data: RedeemPlatformUserPackageItemRequest}

    /**
 * @summary Redeems a PlatformUserPackageItem based on the scanned QR code.
 */
export const useRedeemPlatformUserPackageItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemPlatformUserPackageItem>>, TError,RedeemPlatformUserPackageItemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof redeemPlatformUserPackageItem>>,
        TError,
        RedeemPlatformUserPackageItemMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemPlatformUserPackageItemMutationOptions(options));
    }
    /**
 * @summary Redeems a PlatformUserPackageItem
 */
export const redeemPlatformUserPackageItemInApp = (
    redeemPlatformUserPackageItemInAppRequest: RedeemPlatformUserPackageItemInAppRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformUserPackageItemTransactionModel[]>(
      {url: `/api/v1/platform-user-package-items/redeem-in-app`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: redeemPlatformUserPackageItemInAppRequest, signal
    },
      options);
    }




export const getRedeemPlatformUserPackageItemInAppMutationKey = () => ['redeemPlatformUserPackageItemInApp'] as const;

export const getRedeemPlatformUserPackageItemInAppMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemPlatformUserPackageItemInApp>>, TError,RedeemPlatformUserPackageItemInAppMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemPlatformUserPackageItemInApp>>, TError,RedeemPlatformUserPackageItemInAppMutationVariables, TContext> => {

const mutationKey = getRedeemPlatformUserPackageItemInAppMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemPlatformUserPackageItemInApp>>, RedeemPlatformUserPackageItemInAppMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  redeemPlatformUserPackageItemInApp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemPlatformUserPackageItemInAppMutationResult = NonNullable<Awaited<ReturnType<typeof redeemPlatformUserPackageItemInApp>>>
    export type RedeemPlatformUserPackageItemInAppMutationBody = RedeemPlatformUserPackageItemInAppRequest
    export type RedeemPlatformUserPackageItemInAppMutationError = ErrorType<unknown>
    export type RedeemPlatformUserPackageItemInAppMutationVariables = {data: RedeemPlatformUserPackageItemInAppRequest}

    /**
 * @summary Redeems a PlatformUserPackageItem
 */
export const useRedeemPlatformUserPackageItemInApp = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemPlatformUserPackageItemInApp>>, TError,RedeemPlatformUserPackageItemInAppMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof redeemPlatformUserPackageItemInApp>>,
        TError,
        RedeemPlatformUserPackageItemInAppMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemPlatformUserPackageItemInAppMutationOptions(options));
    }
